export const SET_POPUP_SETTING_STATE = "@SETTINGS/SET_POPUP_SETTING_STATE";
export const RESET_POPUP_SETTING_STATE = "@SETTINGS/RESET_POPUP_SETTING_STATE";
export const INIT_POPUP_SETTING_STATE = "@SETTINGS/INIT_POPUP_SETTING_STATE";
